import axios from 'axios';
import utilities from '../helpers/utility';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  async searchOrder(searchPayload) {
    const lookupPayload = {
      orderNumber: searchPayload.orderNumber || '',
      email: searchPayload.email || '',
      // totalPrice: searchPayload.totalPrice || '',
      customerPurchaseOrder: searchPayload.customerPurchaseOrder || '',
      ccLastFour: searchPayload.ccLastFour || '',
      // address: {
      //   name: searchPayload.name || '',
      //   street: searchPayload.street || '',
      //   city: searchPayload.city || '',
      //   zip: searchPayload.zip || '',
      //   state: searchPayload.state || '',
      //   country: searchPayload.country || '',
      // }
    };

    if (utilities.deepEntries(lookupPayload).map(i => i[1]).filter(i => typeof i === 'string' && i != '').length == 0) {
      return [];
    }

    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shopify/order/search`,
      data: lookupPayload,
    }).then(response => response.data)
      .catch((error) => {
        console.error(error);
        return [];
      });
  },

  async getSalesOrder(id) {
    return axios
      .get(`${BASE_API}/shopify/order/${id}`)
      .then(response => response)
      .catch((error) => {
        console.error('err', error);
        return { exists: false }
      });
  },

  async findShopifyCustomer(email) {
    return axios
      .get(`${BASE_API}/shopify/customer/${email}`)
      .then(response => response)
      .catch((error) => {
        console.error('err', error);
        return { exists: false };
      });
  },

  async sendInviteEmail(gid) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shopify/customer/${gid}/invite`,
    }).then(response => response.data)
      .catch((error) => {
        console.error('err', error)
        return error
      });
  },

  getMetafield(obj, key, namespace = undefined) {
    let f = []

    if (obj.metafields) {
      f = obj.metafields.filter(x => x.key === key)
    } else {
      f = obj.filter(x => x.key === key)
    }

    if (f.length > 1 && namespace) {
      f = f.filter(x => x.namespace === namespace)
    }

    if (f.length === 0) {
      return undefined;
    }

    return f[0]
  },

  getMetafieldValue(obj, key, namespace = undefined) {
    const mf = this.getMetafield(obj, key, namespace);

    if (!mf || !mf.value) {
      return undefined
    }
    return mf.value
  },

  processTaxForm(customerId, taxForm, status) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shopify/customer/${customerId.split('/').at(-1)}/tax-exempt/${status}`,
      data: taxForm,
    }).then(response => response.data).catch((e) => {
      console.error(e);
      return undefined
    })
  },
  fetchTaxTodoCustomers() {
    const taxTodoSegmentId = '455481426092'
    return axios.get(`${BASE_API}/shopify/customer/segment/${taxTodoSegmentId}`).then(response => response.data).catch((e) => {
      console.error(e)
      return []
    })
  },

  fetchReturnPendingApproval() {
    return axios.get(`${BASE_API}/shopify/returns/pending-approval`).then(response => {
      return response.data.sort((a,b) => a.createdAt - b.createdAt);
    }).catch((e) => {
      console.error(e);
      return [];
    })
  },
  fetchReturnPendingReceive() {
    return axios.get(`${BASE_API}/shopify/returns/pending-receive`).then(response => {
      return response.data.sort((a,b) => a.createdAt - b.createdAt);
    }).catch((e) => {
      console.error(e);
      return [];
    })
  },

  approveReturn(id, notifyCustomer) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shopify/returns/pending-approval/approve`,
      data: {
        id,
        notifyCustomer,
      }
    })
  },
  declineReturn(id, notifyCustomer, reason, note) {
    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/shopify/returns/pending-approval/decline`,
      data: {
        id,
        notifyCustomer,
        declineReason: reason,
        declineNote: note
      }
    })
  }
};



// WEBPACK FOOTER //
// /src/services/shopify.js